interface Props { score: number }

export function RiskPill({ score }: Props) {
  const level = riskLevel(score);
  return (
    <span className={`sg-risk-pill ${level.className}`} title={`Risk score ${score}`}>
      <span className="sg-risk-dot" />
      {level.label}
    </span>
  );
}

function riskLevel(score: number) {
  if (score >= 70) return { label: "High", className: "high" };
  if (score >= 40) return { label: "Moderate", className: "moderate" };
  if (score >= 15) return { label: "Low", className: "low" };
  return { label: "Minimal", className: "minimal" };
}
